<style lang="scss"></style>

<template>
  <div id="modal-remove-aditivo" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="aditivo">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover o tipo de aditivo
                    <span
                      class="text-info"
                    >{{ aditivo.nome }}</span>?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../../helpers';
import TipoAditivoService from '../../../services/TipoAditivoService';

export default {
  name: 'modal-remove-aditivo',
  data() {
    return {
      enviando: false,
      aditivo: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-aditivo').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removeAditivoId = null;
    });

    if (this.$parent.removeAditivoId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.aditivo = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removeAditivoId === 0) return;

        this.aditivo = await TipoAditivoService.findById(
          this.$parent.removeAditivoId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-aditivo').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await TipoAditivoService.remove(this.aditivo.id);

        this.$toast.success('Tipo de aditivo removido com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-aditivo').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
